import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useHistory, NavLink } from 'react-router-dom';
import { Get } from '@app/utils/httpProvider';
import { INVENTORY_SESSION_API } from '@app/utils/apiUrl';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { formatDateTimeMoment } from '@app/utils/helper';

const InventoryTab = ({ assetId }) => {
    const history = useHistory();
    const [inventories, setInventories] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchInventories = async () => {
        if (!assetId) return;
        setLoading(true);
        try {
            const res = await Get(INVENTORY_SESSION_API.GET_HISTORY_BY_ASSET(assetId));
            if (res) {
                setInventories(res);
            }
        } catch (error) {
            console.error('Lỗi khi tải lịch sử kiểm kê:', error);
            toast.error('Không thể tải lịch sử kiểm kê tài sản');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInventories();
    }, [assetId]);

    const handleOpenAdd = () => {
        history.push(URI_INTERNAL.INVENTORY_SESSION_CREATE_PATH);
    };

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-primary mb-0 font-weight-bold">
                    <i className="fas fa-clipboard-check mr-2"></i>
                    Lịch sử kiểm kê tài sản
                </h6>
                <button className="btn btn-sm btn-primary shadow-sm" onClick={handleOpenAdd}>
                    <i className="fas fa-plus mr-1"></i> Tạo phiếu kiểm kê
                </button>
            </div>

            <div className="table-responsive">
                <Table bordered hover size="sm" className="bg-white">
                    <thead className="bg-light">
                        <tr>
                            <th className="text-center align-middle" style={{ width: '60px' }}>STT</th>
                            <th className="text-center align-middle">Mã phiếu</th>
                            <th className="text-center align-middle">Tiêu đề phiếu</th>
                            <th className="text-center align-middle">Ngày chốt</th>
                            <th className="text-center align-middle">Trạng thái chốt</th>
                            <th className="text-center align-middle">Cấp CL chốt</th>
                            <th className="text-center align-middle">Đào thải?</th>
                            <th className="text-center align-middle">Người thực hiện</th>
                            <th className="align-middle">Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        ) : inventories.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center text-muted py-3">Chưa có lịch sử kiểm kê nào cho tài sản này</td>
                            </tr>
                        ) : (
                            inventories.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="text-center align-middle">{index + 1}</td>
                                    <td className="text-center align-middle">
                                        <NavLink to={`/kiem-ke-tai-san/chi-tiet/${item.sessionId}`} className="text-primary font-weight-bold">
                                            {item.sessionCode}
                                        </NavLink>
                                    </td>
                                    <td className="align-middle">{item.sessionTitle}</td>
                                    <td className="text-center align-middle">
                                        {item.snapshotDate ? formatDateTimeMoment(item.snapshotDate) : ''}
                                    </td>
                                    <td className="text-center align-middle">
                                        <span 
                                            className="badge px-2 py-1 text-white" 
                                            style={{ 
                                                borderRadius: '4px', 
                                                fontSize: '11px',
                                                backgroundColor: item.statusColor || '#28a745'
                                            }}
                                        >
                                            {item.statusName || 'Bình thường'}
                                        </span>
                                    </td>
                                    <td className="text-center align-middle">
                                        {item.qualityLevelName || 'Cấp 5'}
                                    </td>
                                    <td className="text-center align-middle">
                                        {item.isDisposed ? (
                                            <span className="badge badge-danger px-2 py-1" style={{ borderRadius: '4px', fontSize: '11px' }}>
                                                Đã đào thải
                                            </span>
                                        ) : (
                                            <span className="badge badge-secondary px-2 py-1" style={{ borderRadius: '4px', fontSize: '11px' }}>
                                                Bình thường
                                            </span>
                                        )}
                                    </td>
                                    <td className="align-middle">{item.createdBy || 'Hệ thống'}</td>
                                    <td className="align-middle text-muted small">{item.notes}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default InventoryTab;
